var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { Icon } from "../../tremor/Icon";
import { Input } from "../../tremor/Input";
import { Button } from "../../tremor/Button";
import { useEffect, useState } from "react";
import { create } from "zustand";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { useBackend } from "../../layouts/Wrapper";
import { Text, Label, Title } from "../../tremor/Text";
import { twMerge } from "tailwind-merge";
import { ChevronLeftIcon, ChevronRightIcon, PaperClipIcon, } from "@heroicons/react/20/solid";
import ChartBase from "../Chart/ChartBase";
import { Tabs, TabsList, TabsTrigger } from "../../tremor/Tabs";
import { Divider } from "../../tremor/Divider";
import { Card } from "../../tremor/Card";
import { toast } from "sonner";
import { useMaxHeight } from "../../lib/useMaxHeight";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
export const useImageWidgetModal = create((set) => ({
    open: false,
    setOpen: (op, wid) => set({ open: op, widget: wid }),
}));
export const ImageWidgetModal = ({}) => {
    var _a;
    const { dashboard, refreshWidgets, tab } = useDashboard();
    const { backend, adminMode } = useBackend();
    const { open, setOpen, widget } = useImageWidgetModal();
    const { lg, sm } = useMaxHeight();
    const [url, setUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [imageFill, setImageFill] = useState("fill");
    useEffect(() => {
        if (widget) {
            setUrl(widget.url);
            setImageFill(widget.imageFill);
        }
        else {
            setImageFill("fill");
            setUrl("");
        }
    }, [widget]);
    const createSeparator = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!dashboard || !backend)
            return;
        setLoading(true);
        let cache = {
            type: "image",
            data: { datasets: [{ data: [], label: "" }] },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    image: { url: url, fill: imageFill },
                },
            },
        };
        if (widget) {
            yield backend.widgets.update(widget.id, {
                title: url,
                code: "",
                config: cache,
            });
        }
        else {
            yield backend.widgets.create({
                dashboard: dashboard.id,
                layouts: {
                    lg: {
                        x: 0,
                        y: lg,
                        w: 12,
                        h: 10,
                    },
                    sm: {
                        x: 0,
                        y: sm,
                        w: 3,
                        h: 10,
                    },
                },
                use_in_library: false,
                title: url,
                team: dashboard.team,
                code: "",
                messages: [],
                error: null,
                settings: {},
                tab: tab || 0,
                config: cache,
                engine: "manual-v1",
                type: "image",
            });
        }
        setOpen(false);
        setLoading(false);
        setUrl("");
        refreshWidgets(backend);
    });
    const uploadFile = (e) => __awaiter(void 0, void 0, void 0, function* () {
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            if (!e.target.files)
                return;
            return backend === null || backend === void 0 ? void 0 : backend.utils.uploadFile(e.target.files[0]);
        }), {
            loading: "Uploading file...",
            success: (res) => {
                setUrl(res.url);
                return "File uploaded";
            },
            error: (err) => {
                return "Failed to upload file: " + err.message;
            },
        });
    });
    if (!((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.can_create_widgets) && !adminMode)
        return React.createElement(React.Fragment, null);
    return (React.createElement(React.Fragment, null,
        React.createElement("dialog", { open: open },
            React.createElement("div", { className: twMerge("onvo-@container/widgetmodal onvo-h-full onvo-animate-dialogOpen onvo-w-full onvo-z-50 onvo-fixed onvo-left-0 onvo-top-0 onvo-foreground-color") },
                React.createElement("div", { className: "onvo-foreground-color onvo-w-full onvo-left-0 onvo-top-0 onvo-z-10 onvo-flex onvo-flex-row onvo-justify-start onvo-items-center onvo-gap-4 onvo-border-solid onvo-border-b onvo-border-black/10 onvo-p-2 dark:onvo-border-white/10" },
                    React.createElement(Icon, { icon: ChevronLeftIcon, variant: "shadow", className: "onvo-ml-2 onvo-background-color onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10", onClick: () => setOpen(false) }),
                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-w-full onvo-gap-1 onvo-flex-grow onvo-justify-start onvo-items-center" },
                        React.createElement(Text, { className: "onvo-hidden @xl/widgetmodal:onvo-block" }, dashboard === null || dashboard === void 0 ? void 0 : dashboard.title),
                        React.createElement(ChevronRightIcon, { className: "onvo-hidden @xl/widgetmodal:onvo-block onvo-h-4 onvo-w-4 dark:onvo-fill-slate-500" }),
                        React.createElement(Label, null, widget ? `Edit image widget` : "Create image widget")),
                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-gap-2 onvo-flex-shrink-0" },
                        React.createElement(Button, { onClick: createSeparator, className: "onvo-flex-shrink-0", isLoading: loading }, widget ? "Save" : "Create"))),
                React.createElement("div", { className: "onvo-relative onvo-flex onvo-flex-grow onvo-h-[calc(100%-52px)] onvo-w-full" },
                    React.createElement(PanelGroup, { autoSaveId: "edit-widget", direction: "horizontal" },
                        React.createElement(Panel, { defaultSize: 50, minSize: 25 },
                            React.createElement("div", { className: "onvo-relative onvo-overflow-y-auto onvo-scrollbar-thin onvo-flex-grow onvo-h-full onvo-w-full onvo-p-4 onvo-flex onvo-flex-col onvo-justify-center" },
                                React.createElement(Text, null, "Image URL"),
                                React.createElement(Input, { placeholder: "Type in a URL", value: url, inputClassName: "onvo-background-color onvo-border-black/10 dark:onvo-border-white/10", onChange: (e) => setUrl(e.target.value) }),
                                React.createElement(Divider, null,
                                    React.createElement(Text, null, "OR")),
                                React.createElement(Card, { className: "onvo-background-color onvo-border-black/10 dark:onvo-border-white/10 onvo-relative onvo-flex onvo-h-auto onvo-cursor-pointer onvo-flex-row onvo-items-center onvo-justify-center onvo-py-10" },
                                    React.createElement(Icon, { icon: PaperClipIcon }),
                                    React.createElement("div", { className: "onvo-ml-4 onvo-flex-grow" },
                                        React.createElement(Title, null, "Drag and drop an image here or click to add"),
                                        React.createElement(Text, { className: "onvo-text-xs onvo-italic" }, "Upload .jpeg, .png, .svg files")),
                                    React.createElement("input", { onChange: uploadFile, type: "file", accept: "image/*", className: "onvo-absolute onvo-left-0 onvo-top-0 onvo-z-10 onvo-h-full onvo-w-full onvo-cursor-pointer onvo-opacity-0" })),
                                React.createElement("div", { className: "onvo-mt-4 onvo-flex onvo-items-center onvo-justify-between" },
                                    React.createElement(Text, null, "Image fill"),
                                    React.createElement(Tabs, { value: imageFill, onValueChange: (val) => {
                                            setImageFill(val);
                                        } },
                                        React.createElement(TabsList, { variant: "solid" },
                                            React.createElement(TabsTrigger, { value: "fit" }, "Fit"),
                                            React.createElement(TabsTrigger, { value: "fill" }, "Fill")))))),
                        React.createElement(PanelResizeHandle, { className: "onvo-w-[1px] onvo-border-0 onvo-bg-black/10 dark:onvo-bg-white/10 hover:onvo-bg-black/50 dark:hover:onvo-bg-white/50 active:onvo-bg-black/50 dark:active:onvo-bg-white/50" }),
                        React.createElement(Panel, { minSize: 25 },
                            React.createElement("div", { className: "onvo-h-full onvo-background-color onvo-flex onvo-flex-shrink-0 @xl/widgetmodal:onvo-flex-shrink onvo-flex-col onvo-justify-center onvo-w-full onvo-flex-grow onvo-relative onvo-p-4 onvo-overflow-y-auto onvo-bg-[radial-gradient(#e2e8f0_1px,transparent_1px)] dark:onvo-bg-[radial-gradient(#0f172a_1px,transparent_1px)] [background-size:16px_16px]" },
                                React.createElement("div", { className: "onvo-relative onvo-flex onvo-w-full onvo-flex-col" },
                                    React.createElement(ChartBase, { json: {
                                            type: "image",
                                            data: { datasets: [{ data: [], label: "" }] },
                                            options: {
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    image: {
                                                        url: url,
                                                        fill: imageFill,
                                                    },
                                                },
                                            },
                                        }, title: "" }))))))))));
};
//# sourceMappingURL=ImageWidgetModal.js.map